import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PixelService } from 'ngx-pixel';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { SectionService } from 'src/app/services/section.service';
import { SignatureService } from 'src/app/services/signature.service';

@Component({
  selector: 'app-signature-refuse',
  templateUrl: './signature-refuse.component.html',
  styleUrls: ['./signature-refuse.component.css']
})
export class SignatureRefuseComponent implements OnInit {
  clientId: any;
  language: any;
  refuseText: any;
  headerText: any;

  constructor(private translate: TranslateService,private sectionService: SectionService,
    private pixel:PixelService,private sisgnatureService: SignatureService ,
    private guranteeservice: GuaranteeService, private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,) { }

  ngOnInit() {
    this.sectionService.setCurrentPage('P5-8');
    this.pixel.track('Lead');

    this.activatedRoute.queryParams.subscribe((params) => {
      this.clientId = params.clientId;
      this.language = params.language;

      if (this.language === null || this.language === undefined)
      {
        this.language = this.guranteeservice.getLanguage();
      }

      if (this.language === null || this.language === undefined) {this.loadRefuseText('FR'); }
      else {this.loadRefuseText(this.language.toUpperCase()); }
    });
    this.guranteeservice.langvalue.subscribe(value => {
      this.loadRefuseText(value);
    });

  }
  loadRefuseText(langValue) {
    if (langValue === 'FR') {this.headerText = this.sanitizer.bypassSecurityTrustHtml('Le processus a été interrompu !');}
    else {this.headerText = this.sanitizer.bypassSecurityTrustHtml('Het proces werd onderbroken!');}
    this.guranteeservice.getDataRefuse(langValue).subscribe(data => {
      this.refuseText = this.sanitizer.bypassSecurityTrustHtml(data);
    });
  }

}
